<template>
  <div :class="`${classes} ${noMargin ? '' : 'vertical-offset4'}`">
    <slot name="title">
      <tr-typography
        class="no-margin"
        strong="true"
        variant="h3"
      >
        {{ title }}
      </tr-typography>
    </slot>
    <div class="vertical-offset2">
      <slot name="description">
        <p>
          {{ description }}
        </p>
      </slot>
    </div>
    <div :class="`${noMarginOnDescription ? '' : 'vertical-offset3'}`">
      <slot />
    </div>
  </div>
</template>

<script>
import TrTypography from './TrTypography.vue'

export default {
  name: 'TrPageSection',
  components: {
    TrTypography
  },
  props: {
    title: {
      required: false,
      type: String,
      default: ''
    },
    description: {
      required: false,
      type: String,
      default: ''
    },
    classes: {
      required: false,
      type: String,
      default: ''
    },
    noMargin: {
      required: false,
      type: Boolean,
      default: false
    },
    noMarginOnDescription: {
      required: false,
      type: Boolean,
      default: false
    }
  }
};
</script>
